import React, {Component} from 'react';
import './ButtonInput.scss';

export default class ButtonInput extends Component {
  render() {
    const {
      action,
      defaultValue,
      disabled,
      disabledButton,
      formKey,
      hideLabel,
      icon,
      onChange,
      placeholder,
      type,
      value
    } = this.props;
    const label = formKey === 'email' ?
      'email me a copy of my links' :
      formKey.replace(/_/g, ' ').toLowerCase();
    return (
      <form className="buttoninput" onSubmit={action}>
        {!hideLabel && <label className="buttoninput-label" htmlFor={formKey}>{label}</label>}
        <div className="input-group">
          <input
            className="form-control"
            defaultValue={defaultValue}
            disabled={disabled}
            name={formKey}
            onChange={onChange}
            placeholder={placeholder}
            required
            type={type}
            value={value}
          />
          <span className="input-group-btn">
            <button
              className="btn btn-primary"
              disabled={disabledButton}
              type="submit"
            >
              <i className={'fa fa-'+icon}/>
            </button>
          </span>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/ButtonInput.jsx